module.exports = require("./lib/_stream_transform.js")



//////////////////
// WEBPACK FOOTER
// (webpack)/~/node-libs-browser/~/readable-stream/transform.js
// module id = 702
// module chunks = 0